/**
 * Auth context definition - separated to comply with react-refresh rules.
 */

import { createContext } from 'react'
import type { UseAuthReturn } from './useAuth.js'

export const AuthContext = createContext<UseAuthReturn | null>(null)
